import React from 'react';
import { connect } from 'react-redux';
import { getEquipmentForBuilding } from '../../redux/selectors/equipment';
import Selector from '../util/Selector';

export const UnconnectedEquipmentSelector = ({
  equipment,
  selected,
  onValueChange,
  disabled,
  filter = () => true,
  displayNameRender = null,
}) => (
  <Selector
    options={equipment.filter(filter).map((e) => ({
      id: e.id,
      key: `${e.id}`,
      display: displayNameRender == null ? `${e.typeName} ${e.suffix}` : displayNameRender(e),
    }))}
    selected={selected ? `${selected}` : ''}
    onChange={(e) => onValueChange(e.target.value)}
    disabled={disabled}
  />
);

export default connect((state, { buildingId }) => ({
  equipment: getEquipmentForBuilding(state, buildingId).flat(),
}))(UnconnectedEquipmentSelector);
